<template>
  <header class="header" v-if="Nosologys" :key="$route.path.length">
    <div
      v-if="
        Object.keys(user).length && typeof user === 'object' && !user.verified
      "
      class="verify-block"
    >
      Вы ещё неверифицированный пользователь
    </div>
    <div class="content">
      <div class="header__row" ref="helperContainer">
        <router-link :to="{ name: 'MainPage' }" class="header__logo">
          <svg
            v-if="!theme"
            height="40"
            viewBox="0 0 140 49"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="56.8574" cy="4.07129" r="2" fill="#F0AB00" />
            <circle cx="56.0003" cy="9.49979" r="1.14286" fill="#9DB0AC" />
            <circle cx="52.5716" cy="9.49979" r="1.14286" fill="#9DB0AC" />
            <circle cx="49.1429" cy="11.2141" r="1.14286" fill="#9DB0AC" />
            <circle cx="47.429" cy="14.0711" r="1.14286" fill="#9DB0AC" />
            <circle cx="47.429" cy="17.4998" r="1.14286" fill="#9DB0AC" />
            <circle cx="49.1429" cy="20.3572" r="1.14286" fill="#9DB0AC" />
            <circle cx="52.0003" cy="21.4998" r="1.14286" fill="#9DB0AC" />
            <circle cx="54.8567" cy="23.2141" r="1.14286" fill="#9DB0AC" />
            <circle cx="56.5716" cy="26.0711" r="1.14286" fill="#9DB0AC" />
            <circle cx="56.5716" cy="28.9285" r="1.14286" fill="#9DB0AC" />
            <circle cx="54.8567" cy="31.7854" r="1.14286" fill="#9DB0AC" />
            <circle cx="52.0003" cy="33.4998" r="1.14286" fill="#9DB0AC" />
            <circle cx="48.0003" cy="34.0711" r="1.14286" fill="#9DB0AC" />
            <circle cx="50" cy="4.64258" r="2" fill="#F0AB00" />
            <circle cx="44.8574" cy="8.07129" r="2" fill="#F0AB00" />
            <circle cx="42.5713" cy="12.6426" r="2" fill="#F0AB00" />
            <circle cx="42" cy="18.3569" r="2" fill="#F0AB00" />
            <circle cx="44.8574" cy="23.5" r="2" fill="#F0AB00" />
            <circle cx="49.4287" cy="26.9282" r="2" fill="#F0AB00" />
            <circle cx="54.5713" cy="16.0713" r="2" fill="#830051" />
            <circle cx="59.1426" cy="19.5" r="2" fill="#830051" />
            <circle cx="62" cy="24.0713" r="2" fill="#830051" />
            <circle cx="61.4287" cy="30.3569" r="2" fill="#830051" />
            <circle cx="59.1426" cy="34.9282" r="2" fill="#830051" />
            <circle cx="54" cy="38.3569" r="2" fill="#830051" />
            <circle cx="47.1426" cy="38.9282" r="2" fill="#830051" />
            <path
              d="M5.56934 33.5V31.8457L6.70801 31.6846L11.8857 17.8594H14.5176L19.6309 31.6846L20.7695 31.8457V33.5H15.7959V31.8457L16.9131 31.6416L16.0859 29.1816H10.2637L9.41504 31.6416L10.543 31.8457V33.5H5.56934ZM10.9727 27.1084H15.3877L13.3574 21.3184L13.2178 20.8994H13.1533L13.0029 21.3398L10.9727 27.1084ZM22.2197 33.5V31.6309L30.0615 19.9541H24.7441L24.5186 21.9629H22.4131L22.4883 17.8594H33.3164V19.6748L25.4424 31.416H31.3936L31.6191 29.3213H33.7139L33.6064 33.5H22.2197Z"
              fill="#F0AB00"
            />
            <path
              d="M69.7734 33.5V31.8457L71.4707 31.5234V19.8467L69.7734 19.5244V17.8594H71.4707H75.3486L79.9355 29.1709H80L84.4473 17.8594H90.0869V19.5244L88.3789 19.8467V31.5234L90.0869 31.8457V33.5H83.9746V31.8457L85.7686 31.5234V27.8818L85.79 21.0391L85.7363 21.0283L80.8916 33.1455H78.9258L73.9414 21.0928L73.8877 21.1035L74.0273 27.6992V31.5234L75.8857 31.8457V33.5H69.7734ZM98.3799 33.7256C97.3415 33.7256 96.4033 33.5322 95.5654 33.1455C94.7275 32.7516 94.0078 32.2002 93.4062 31.4912C92.8118 30.7822 92.3535 29.9443 92.0312 28.9775C91.709 28.0107 91.5479 26.9508 91.5479 25.7979V25.5615C91.5479 24.4157 91.709 23.3594 92.0312 22.3926C92.3535 21.4258 92.8118 20.5879 93.4062 19.8789C94.0078 19.1628 94.7275 18.6113 95.5654 18.2246C96.4033 17.8307 97.3379 17.6338 98.3691 17.6338C99.4362 17.6338 100.392 17.8307 101.237 18.2246C102.082 18.6113 102.802 19.1628 103.396 19.8789C103.991 20.5879 104.446 21.4258 104.761 22.3926C105.076 23.3594 105.233 24.4157 105.233 25.5615V25.7979C105.233 26.9508 105.076 28.0107 104.761 28.9775C104.446 29.9443 103.991 30.7822 103.396 31.4912C102.802 32.2002 102.082 32.7516 101.237 33.1455C100.392 33.5322 99.4398 33.7256 98.3799 33.7256ZM98.3799 31.5771C99.3252 31.5771 100.102 31.3372 100.711 30.8574C101.327 30.3704 101.782 29.6937 102.075 28.8271C102.376 27.9606 102.526 26.9508 102.526 25.7979V25.54C102.526 24.4014 102.376 23.4023 102.075 22.543C101.774 21.6836 101.316 21.0104 100.7 20.5234C100.091 20.0365 99.3145 19.793 98.3691 19.793C97.4668 19.793 96.7113 20.0365 96.1025 20.5234C95.4938 21.0104 95.0355 21.6836 94.7275 22.543C94.4196 23.4023 94.2656 24.4014 94.2656 25.54V25.7979C94.2656 26.9437 94.4196 27.9535 94.7275 28.8271C95.0355 29.6937 95.4938 30.3704 96.1025 30.8574C96.7184 31.3372 97.4775 31.5771 98.3799 31.5771ZM112.71 33.7256C111.643 33.7256 110.651 33.5931 109.734 33.3281C108.818 33.0632 107.926 32.6227 107.06 32.0068V28.4082H109.154L109.498 30.7393C109.878 31.0114 110.343 31.2298 110.895 31.3945C111.453 31.5592 112.058 31.6416 112.71 31.6416C113.347 31.6416 113.881 31.5521 114.311 31.373C114.747 31.1868 115.08 30.929 115.31 30.5996C115.539 30.2702 115.653 29.8799 115.653 29.4287C115.653 29.0133 115.553 28.6445 115.353 28.3223C115.152 28 114.819 27.7135 114.354 27.4629C113.888 27.2051 113.258 26.9688 112.463 26.7539C111.296 26.4388 110.318 26.0664 109.53 25.6367C108.75 25.207 108.159 24.6914 107.758 24.0898C107.364 23.4883 107.167 22.7793 107.167 21.9629C107.167 21.125 107.393 20.3838 107.844 19.7393C108.302 19.0947 108.936 18.5863 109.745 18.2139C110.554 17.8415 111.489 17.6517 112.549 17.6445C113.709 17.6302 114.733 17.7806 115.621 18.0957C116.516 18.4108 117.272 18.8226 117.888 19.3311V22.6934H115.836L115.449 20.502C115.156 20.2943 114.772 20.1188 114.3 19.9756C113.834 19.8252 113.283 19.75 112.646 19.75C112.101 19.75 111.621 19.8395 111.206 20.0186C110.791 20.1976 110.465 20.4518 110.229 20.7812C109.992 21.1035 109.874 21.4902 109.874 21.9414C109.874 22.3353 109.978 22.679 110.186 22.9727C110.393 23.2663 110.741 23.5348 111.228 23.7783C111.715 24.0146 112.373 24.2546 113.204 24.498C114.901 24.9492 116.187 25.5723 117.061 26.3672C117.934 27.1621 118.371 28.1755 118.371 29.4072C118.371 30.2738 118.135 31.0329 117.662 31.6846C117.197 32.3291 116.538 32.8304 115.686 33.1885C114.84 33.5465 113.849 33.7256 112.71 33.7256ZM123.57 33.5V31.8457L125.278 31.5234V19.9326H122.131L121.895 21.9307H119.864V17.8594H133.41V21.9307H131.369L131.133 19.9326H127.985V31.5234L129.693 31.8457V33.5H123.57Z"
              fill="#830051"
            />
          </svg>
          <svg
            v-else
            width="130"
            height="40"
            viewBox="0 0 130 40"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M65.2041 26V24.3457L66.9014 24.0234V12.3467L65.2041 12.0244V10.3594H66.9014H70.7793L75.3662 21.6709H75.4307L79.8779 10.3594H85.5176V12.0244L83.8096 12.3467V24.0234L85.5176 24.3457V26H79.4053V24.3457L81.1992 24.0234V20.3818L81.2207 13.5391L81.167 13.5283L76.3223 25.6455H74.3564L69.3721 13.5928L69.3184 13.6035L69.458 20.1992V24.0234L71.3164 24.3457V26H65.2041Z"
              fill="white"
            />
            <path
              d="M93.8105 26.2256C92.7721 26.2256 91.834 26.0322 90.9961 25.6455C90.1582 25.2516 89.4385 24.7002 88.8369 23.9912C88.2425 23.2822 87.7842 22.4443 87.4619 21.4775C87.1396 20.5107 86.9785 19.4508 86.9785 18.2979V18.0615C86.9785 16.9157 87.1396 15.8594 87.4619 14.8926C87.7842 13.9258 88.2425 13.0879 88.8369 12.3789C89.4385 11.6628 90.1582 11.1113 90.9961 10.7246C91.834 10.3307 92.7686 10.1338 93.7998 10.1338C94.8669 10.1338 95.8229 10.3307 96.668 10.7246C97.513 11.1113 98.2327 11.6628 98.8271 12.3789C99.4216 13.0879 99.8763 13.9258 100.191 14.8926C100.507 15.8594 100.664 16.9157 100.664 18.0615V18.2979C100.664 19.4508 100.507 20.5107 100.191 21.4775C99.8763 22.4443 99.4216 23.2822 98.8271 23.9912C98.2327 24.7002 97.513 25.2516 96.668 25.6455C95.8229 26.0322 94.8704 26.2256 93.8105 26.2256ZM93.8105 24.0771C94.7559 24.0771 95.5329 23.8372 96.1416 23.3574C96.7575 22.8704 97.2122 22.1937 97.5059 21.3271C97.8066 20.4606 97.957 19.4508 97.957 18.2979V18.04C97.957 16.9014 97.8066 15.9023 97.5059 15.043C97.2051 14.1836 96.7467 13.5104 96.1309 13.0234C95.5221 12.5365 94.7451 12.293 93.7998 12.293C92.8975 12.293 92.1419 12.5365 91.5332 13.0234C90.9245 13.5104 90.4661 14.1836 90.1582 15.043C89.8503 15.9023 89.6963 16.9014 89.6963 18.04V18.2979C89.6963 19.4437 89.8503 20.4535 90.1582 21.3271C90.4661 22.1937 90.9245 22.8704 91.5332 23.3574C92.1491 23.8372 92.9082 24.0771 93.8105 24.0771Z"
              fill="white"
            />
            <path
              d="M108.141 26.2256C107.074 26.2256 106.082 26.0931 105.165 25.8281C104.248 25.5632 103.357 25.1227 102.49 24.5068V20.9082H104.585L104.929 23.2393C105.308 23.5114 105.774 23.7298 106.325 23.8945C106.884 24.0592 107.489 24.1416 108.141 24.1416C108.778 24.1416 109.312 24.0521 109.741 23.873C110.178 23.6868 110.511 23.429 110.74 23.0996C110.969 22.7702 111.084 22.3799 111.084 21.9287C111.084 21.5133 110.984 21.1445 110.783 20.8223C110.583 20.5 110.25 20.2135 109.784 19.9629C109.319 19.7051 108.688 19.4688 107.894 19.2539C106.726 18.9388 105.749 18.5664 104.961 18.1367C104.18 17.707 103.59 17.1914 103.188 16.5898C102.795 15.9883 102.598 15.2793 102.598 14.4629C102.598 13.625 102.823 12.8838 103.274 12.2393C103.733 11.5947 104.367 11.0863 105.176 10.7139C105.985 10.3415 106.92 10.1517 107.979 10.1445C109.14 10.1302 110.164 10.2806 111.052 10.5957C111.947 10.9108 112.702 11.3226 113.318 11.8311V15.1934H111.267L110.88 13.002C110.586 12.7943 110.203 12.6188 109.73 12.4756C109.265 12.3252 108.714 12.25 108.076 12.25C107.532 12.25 107.052 12.3395 106.637 12.5186C106.221 12.6976 105.896 12.9518 105.659 13.2812C105.423 13.6035 105.305 13.9902 105.305 14.4414C105.305 14.8353 105.409 15.179 105.616 15.4727C105.824 15.7663 106.171 16.0348 106.658 16.2783C107.145 16.5146 107.804 16.7546 108.635 16.998C110.332 17.4492 111.618 18.0723 112.491 18.8672C113.365 19.6621 113.802 20.6755 113.802 21.9072C113.802 22.7738 113.565 23.5329 113.093 24.1846C112.627 24.8291 111.968 25.3304 111.116 25.6885C110.271 26.0465 109.279 26.2256 108.141 26.2256Z"
              fill="white"
            />
            <path
              d="M119.001 26V24.3457L120.709 24.0234V12.4326H117.562L117.325 14.4307H115.295V10.3594H128.841V14.4307H126.8L126.563 12.4326H123.416V24.0234L125.124 24.3457V26H119.001Z"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M52.1197 14.3601C52.1197 15.4931 51.2012 16.4115 50.0682 16.4115C48.9352 16.4115 48.0168 15.4931 48.0168 14.3601C48.0168 13.2271 48.9352 12.3086 50.0682 12.3086C51.2012 12.3086 52.1197 13.2271 52.1197 14.3601ZM56.8085 17.877C56.8085 19.01 55.89 19.9285 54.757 19.9285C53.624 19.9285 52.7056 19.01 52.7056 17.877C52.7056 16.744 53.624 15.8255 54.757 15.8255C55.89 15.8255 56.8085 16.744 56.8085 17.877ZM57.688 24.6174C58.821 24.6174 59.7395 23.6989 59.7395 22.5659C59.7395 21.433 58.821 20.5145 57.688 20.5145C56.555 20.5145 55.6365 21.433 55.6365 22.5659C55.6365 23.6989 56.555 24.6174 57.688 24.6174ZM59.1533 29.0134C59.1533 30.1464 58.2348 31.0649 57.1019 31.0649C55.9689 31.0649 55.0504 30.1464 55.0504 29.0134C55.0504 27.8804 55.9689 26.962 57.1019 26.962C58.2348 26.962 59.1533 27.8804 59.1533 29.0134ZM54.757 35.7538C55.89 35.7538 56.8085 34.8353 56.8085 33.7023C56.8085 32.5693 55.89 31.6508 54.757 31.6508C53.624 31.6508 52.7056 32.5693 52.7056 33.7023C52.7056 34.8353 53.624 35.7538 54.757 35.7538ZM51.5336 37.2193C51.5336 38.3523 50.6151 39.2708 49.4821 39.2708C48.3491 39.2708 47.4306 38.3523 47.4306 37.2193C47.4306 36.0863 48.3491 35.1678 49.4821 35.1678C50.6151 35.1678 51.5336 36.0863 51.5336 37.2193ZM42.4482 39.8567C43.5812 39.8567 44.4997 38.9382 44.4997 37.8052C44.4997 36.6722 43.5812 35.7538 42.4482 35.7538C41.3152 35.7538 40.3967 36.6722 40.3967 37.8052C40.3967 38.9382 41.3152 39.8567 42.4482 39.8567Z"
              fill="white"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M52.7061 7.61953C52.7061 8.26696 52.1813 8.7918 51.5338 8.7918C50.8864 8.7918 50.3616 8.26696 50.3616 7.61953C50.3616 6.97211 50.8864 6.44727 51.5338 6.44727C52.1813 6.44727 52.7061 6.97211 52.7061 7.61953ZM49.189 7.61961C49.189 8.26703 48.6642 8.79187 48.0168 8.79187C47.3693 8.79187 46.8445 8.26703 46.8445 7.61961C46.8445 6.97218 47.3693 6.44734 48.0168 6.44734C48.6642 6.44734 49.189 6.97218 49.189 7.61961ZM44.4999 10.5503C45.1474 10.5503 45.6722 10.0254 45.6722 9.37801C45.6722 8.73058 45.1474 8.20574 44.4999 8.20574C43.8525 8.20574 43.3277 8.73058 43.3277 9.37801C43.3277 10.0254 43.8525 10.5503 44.4999 10.5503ZM43.9142 12.3085C43.9142 12.9559 43.3894 13.4807 42.742 13.4807C42.0945 13.4807 41.5697 12.9559 41.5697 12.3085C41.5697 11.661 42.0945 11.1362 42.742 11.1362C43.3894 11.1362 43.9142 11.661 43.9142 12.3085ZM42.742 16.9977C43.3894 16.9977 43.9142 16.4728 43.9142 15.8254C43.9142 15.178 43.3894 14.6531 42.742 14.6531C42.0945 14.6531 41.5697 15.178 41.5697 15.8254C41.5697 16.4728 42.0945 16.9977 42.742 16.9977ZM45.6722 18.7562C45.6722 19.4036 45.1474 19.9284 44.4999 19.9284C43.8525 19.9284 43.3277 19.4036 43.3277 18.7562C43.3277 18.1087 43.8525 17.5839 44.4999 17.5839C45.1474 17.5839 45.6722 18.1087 45.6722 18.7562ZM47.4309 21.1006C48.0783 21.1006 48.6032 20.5758 48.6032 19.9284C48.6032 19.2809 48.0783 18.7561 47.4309 18.7561C46.7835 18.7561 46.2586 19.2809 46.2586 19.9284C46.2586 20.5758 46.7835 21.1006 47.4309 21.1006ZM51.5331 21.6868C51.5331 22.3343 51.0083 22.8591 50.3609 22.8591C49.7134 22.8591 49.1886 22.3343 49.1886 21.6868C49.1886 21.0394 49.7134 20.5146 50.3609 20.5146C51.0083 20.5146 51.5331 21.0394 51.5331 21.6868ZM52.1197 25.7898C52.7671 25.7898 53.292 25.2649 53.292 24.6175C53.292 23.9701 52.7671 23.4452 52.1197 23.4452C51.4723 23.4452 50.9474 23.9701 50.9474 24.6175C50.9474 25.2649 51.4723 25.7898 52.1197 25.7898ZM53.292 27.5482C53.292 28.1956 52.7671 28.7204 52.1197 28.7204C51.4723 28.7204 50.9474 28.1956 50.9474 27.5482C50.9474 26.9008 51.4723 26.3759 52.1197 26.3759C52.7671 26.3759 53.292 26.9008 53.292 27.5482ZM50.3609 31.651C51.0083 31.651 51.5331 31.1261 51.5331 30.4787C51.5331 29.8313 51.0083 29.3064 50.3609 29.3064C49.7134 29.3064 49.1886 29.8313 49.1886 30.4787C49.1886 31.1261 49.7134 31.651 50.3609 31.651ZM48.6032 32.2372C48.6032 32.8846 48.0783 33.4095 47.4309 33.4095C46.7835 33.4095 46.2586 32.8846 46.2586 32.2372C46.2586 31.5898 46.7835 31.0649 47.4309 31.0649C48.0783 31.0649 48.6032 31.5898 48.6032 32.2372ZM43.328 33.9954C43.9754 33.9954 44.5002 33.4706 44.5002 32.8232C44.5002 32.1758 43.9754 31.6509 43.328 31.6509C42.6805 31.6509 42.1557 32.1758 42.1557 32.8232C42.1557 33.4706 42.6805 33.9954 43.328 33.9954Z"
              fill="#9DB0AC"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M54.4646 2.05147C54.4646 3.18447 53.5461 4.10294 52.4131 4.10294C51.2801 4.10294 50.3616 3.18447 50.3616 2.05147C50.3616 0.918475 51.2801 0 52.4131 0C53.5461 0 54.4646 0.918475 54.4646 2.05147ZM47.4307 2.6376C47.4307 3.7706 46.5122 4.68907 45.3792 4.68907C44.2462 4.68907 43.3277 3.7706 43.3277 2.6376C43.3277 1.50461 44.2462 0.586132 45.3792 0.586132C46.5122 0.586132 47.4307 1.50461 47.4307 2.6376ZM40.1043 8.20588C41.2373 8.20588 42.1557 7.28741 42.1557 6.15441C42.1557 5.02142 41.2373 4.10294 40.1043 4.10294C38.9713 4.10294 38.0528 5.02142 38.0528 6.15441C38.0528 7.28741 38.9713 8.20588 40.1043 8.20588ZM39.8109 10.8435C39.8109 11.9765 38.8924 12.895 37.7594 12.895C36.6264 12.895 35.708 11.9765 35.708 10.8435C35.708 9.71049 36.6264 8.79202 37.7594 8.79202C38.8924 8.79202 39.8109 9.71049 39.8109 10.8435ZM37.1733 18.7563C38.3063 18.7563 39.2248 17.8378 39.2248 16.7048C39.2248 15.5718 38.3063 14.6534 37.1733 14.6534C36.0403 14.6534 35.1218 15.5718 35.1218 16.7048C35.1218 17.8378 36.0403 18.7563 37.1733 18.7563ZM42.1557 21.9802C42.1557 23.1132 41.2373 24.0317 40.1043 24.0317C38.9713 24.0317 38.0528 23.1132 38.0528 21.9802C38.0528 20.8472 38.9713 19.9287 40.1043 19.9287C41.2373 19.9287 42.1557 20.8472 42.1557 21.9802ZM44.793 27.5483C45.926 27.5483 46.8445 26.6299 46.8445 25.4969C46.8445 24.3639 45.926 23.4454 44.793 23.4454C43.6601 23.4454 42.7416 24.3639 42.7416 25.4969C42.7416 26.6299 43.6601 27.5483 44.793 27.5483Z"
              fill="white"
            />
            <path
              d="M1 26V24.3457L2.13867 24.1846L7.31641 10.3594H9.94824L15.0615 24.1846L16.2002 24.3457V26H11.2266V24.3457L12.3438 24.1416L11.5166 21.6816H5.69434L4.8457 24.1416L5.97363 24.3457V26H1ZM6.40332 19.6084H10.8184L8.78809 13.8184L8.64844 13.3994H8.58398L8.43359 13.8398L6.40332 19.6084Z"
              fill="white"
            />
            <path
              d="M17.6504 26V24.1309L25.4922 12.4541H20.1748L19.9492 14.4629H17.8438L17.9189 10.3594H28.7471V12.1748L20.873 23.916H26.8242L27.0498 21.8213H29.1445L29.0371 26H17.6504Z"
              fill="white"
            />
          </svg>
        </router-link>
        <div
          class="header__menu header-menu header-menu_top d-none d-xl-flex"
          v-if="!$root.isMobile && !$root.isTablet"
        >
          <div
            class="header-menu__group"
            v-for="(group, ind) in topMenu.filter((el) => !el.hide)"
            v-show="!group.hide"
            :key="ind"
          >
            <div class="header-menu__item">
              <div
                @click="
                  toMenuItemFull(group.link, group.title, group.title, 'None')
                "
                v-html="group.title"
                :data-id="group.ref"
                class="header-menu__link"
              ></div>
              <div class="header-menu__item-icon" v-if="group.childrens">
                <!-- v-if="group.childrens"-->
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14 5.49988L9 10.4999L4 5.49988"
                    stroke="currentColor"
                    stroke-linecap="square"
                  />
                </svg>
              </div>
            </div>

            <div
              class="header-menu__list header-menu__list_l2"
              v-if="group.childrens && group.childrens.length"
            >
              <div class="header-menu__list_l2-overflow">
                <div
                  class="header-menu__group"
                  v-for="(children, ind) in group.childrens"
                  :key="ind"
                >
                  <div class="header-menu__item">
                    <div
                      v-if="typeof children.link === 'object'"
                      @click="
                        toMenuItemFull(
                          children.link,
                          children.title,
                          group.title,
                          children.title
                        )
                      "
                      class="header-menu__link"
                    >
                      <span v-html="children.title"></span>
                      <div
                        class="header-menu__item-icon"
                        v-if="children.childrens"
                      >
                        <svg
                          width="7"
                          height="12"
                          viewBox="0 0 7 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L6 6L1 11"
                            stroke="currentColor"
                            stroke-linecap="square"
                          />
                        </svg>
                      </div>
                    </div>
                    <div
                      @click="
                        toMenuItemFull(
                          children.link,
                          children.title,
                          group.title,
                          children.title
                        )
                      "
                      v-else
                      class="header-menu__link"
                    >
                      <span v-html="children.title"></span>
                      <div
                        class="header-menu__item-icon"
                        v-if="children.childrens"
                      >
                        <svg
                          width="7"
                          height="12"
                          viewBox="0 0 7 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L6 6L1 11"
                            stroke="currentColor"
                            stroke-linecap="square"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div
                    class="header-menu__list header-menu__list_l3"
                    v-if="children.childrens && children.childrens.length"
                  >
                    <div
                      class="header-menu__list-title"
                      v-html="children.title"
                    ></div>
                    <span v-for="(link, ind) in children.childrens" :key="ind">
                      <div
                        @click="
                          toMenuItemFull(
                            link.link,
                            link.title,
                            group.title,
                            children.title
                          )
                        "
                        class="header-menu__link"
                        :class="{
                          'header-menu__link_subgroup':
                            link.type === 'subgroup',
                        }"
                        v-html="link.title"
                      ></div>
                      <div
                        class="header-menu__list_l4"
                        v-if="link.diseases && link.diseases.length"
                      >
                        <span
                          v-for="(link_l4, ind) in link.diseases"
                          :key="ind"
                        >
                          <div
                            @click="
                              toMenuItemFull(
                                link_l4.link,
                                link_l4.title,
                                group.title,
                                children.title
                              )
                            "
                            class="header-menu__link"
                            v-html="link_l4.title"
                          ></div>
                        </span>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="header__container"
          :class="{ header__container_opened: searchOpened }"
        >
          <div class="header__search-input-container" v-if="searchOpened">
            <div class="header__search-input">
              <div class="header__search">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="10.5"
                    cy="10.4999"
                    r="6"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="square"
                  />
                  <path
                    d="M15 14.9999L19.5 19.4999"
                    stroke="currentColor"
                    stroke-width="1.5"
                    stroke-linecap="square"
                  />
                </svg>
              </div>
              <input
                type="text"
                v-model="search"
                placeholder="Введите запрос..."
              />
              <div
                class="header__search-results"
                v-if="searchResults && searchResults.length"
              >
                <div
                  @click="searchResultClick(res)"
                  class="header__search-result"
                  v-html="res.title"
                  v-for="(res, ind) in searchResults"
                  :key="ind"
                ></div>
              </div>
            </div>
            <div class="header__search-close" @click="closeSearch()">
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.25 5.25L18.75 18.75"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="square"
                />
                <path
                  d="M18.75 5.25L5.25 18.75"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="square"
                />
              </svg>
            </div>
          </div>
        </div>

        <div class="header__tools">
          <div
            class="header__search custom-title custom-title_v-bottom custom-title_h-center"
            data-hint="Поиск по сайту"
            data-id="headerSearch"
            v-if="!searchOpened && isAuth"
            @click="toSearchIcon()"
          >
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="10.5"
                cy="10.4999"
                r="6"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="square"
              />
              <path
                d="M15 14.9999L19.5 19.4999"
                stroke="currentColor"
                stroke-width="1.5"
                stroke-linecap="square"
              />
            </svg>
          </div>

          <div
            @click="toMedInfo"
            v-if="!hideButton"
            class="header__register button d-none d-xl-flex"
            :class="{
              'button_empty-white': theme,
              'button_empty-dark-gray': !theme,
            }"
          >
            Сервис МедИнфо
          </div>
          <a
            :href="$root.ssoLinks.registration"
            class="header__register button button_empty-pink d-none d-xl-flex"
            :class="{ 'button_empty-white': theme }"
            v-if="!isAuth && !disabledPages.includes($route.name)"
          >
            Зарегистрироваться
          </a>
          <!-- <router-link
            :to="{
              name: 'Register',
              query: this.$route.query.email
                ? { email: this.$route.query.email || '' }
                : null,
            }"
            class="header__register button button_empty-pink d-none d-xl-flex"
            :class="{ 'button_empty-white': theme }"
            v-if="
              !isAuth &&
              !getLocalStorageItem('token') &&
              !disabledPages.includes($route.name)
            "
          >
            Зарегистрироваться
          </router-link> -->
          <!-- <div
            class="header__sign-in button button_pink d-none d-xl-flex"
            @click="openAuth = true"
            v-if="
              !isAuth &&
              !getLocalStorageItem('token') &&
              !disabledPages.includes($route.name)
            "
          >
            Войти
          </div> -->
          <a
            :href="$root.ssoLinks.login"
            class="header__sign-in button button_pink d-none d-xl-flex"
            v-if="!isAuth && !disabledPages.includes($route.name)"
          >
            Войти
          </a>
          <div
            @click="toCabinet({ name: 'Materials' })"
            data-id="headerCabinet"
            class="header__cabinet-button button button_pink px-4 ml-4"
            v-if="isAuth && !$root.isMobile && !$root.isTablet"
          >
            <svg
              class="mr-2"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle
                cx="12"
                cy="6.75"
                r="3.75"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="square"
              />
              <ellipse
                cx="12"
                cy="16.875"
                rx="6.75"
                ry="4.125"
                stroke="white"
                stroke-width="1.5"
                stroke-linecap="square"
              />
            </svg>
            Мой AZ-MOST

            <!-- class="header__user header-user d-none d-xl-flex" -->
            <!-- <div class="header-user__image-container">
              <img
                class="header-user__image"
                :src="
                  user.photo
                    ? $root.host + user.photo
                    : user.default_photo ||
                      `https://storage.yandexcloud.net/${$root.backetName}/media/content/public/content/cabinet/default-avatar.svg`
                "
              />
            </div>
            <div class="header-user__name">
              {{ user.first_name }}
            </div> -->
          </div>
          <div class="header__notify-wrap ml-4" v-if="isAuth">
            <div
              class="header__notify custom-title custom-title_v-bottom custom-title_h-center"
              data-hint="Уведомления"
              @click="toggleNotify()"
            >
              <div
                class="header__notify-sticker"
                v-if="notify.filter((el) => !el.seen).length"
              ></div>
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M5.47246 19.4094C4.93546 19.4097 4.5 18.9745 4.5 18.4375V18.4375C4.5 17.9193 4.92145 17.4973 5.38721 17.2703C5.87968 17.0303 6.39375 16.5547 6.39375 15.6149V9.61492C6.39375 9.61492 6.375 4.63867 11.7487 4.63867C16.5 4.63867 17.625 7.40617 17.625 9.43492V15.9524C17.625 15.9524 17.5334 16.9917 18.5785 17.3818C19.0637 17.5629 19.5 17.9473 19.5 18.4652V18.4652C19.5 18.9829 19.0804 19.4026 18.5627 19.4029L5.47246 19.4094Z"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
                <path
                  d="M13.4657 4.7816V4.2641C13.4657 3.87523 13.3112 3.50228 13.0362 3.22731C12.7613 2.95233 12.3883 2.79785 11.9995 2.79785C11.6106 2.79785 11.2376 2.95233 10.9627 3.22731C10.6877 3.50228 10.5332 3.87523 10.5332 4.2641V4.7366"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
                <path
                  d="M13.585 20C13.585 20.4754 13.3961 20.9313 13.06 21.2675C12.7238 21.6036 12.2679 21.7925 11.7925 21.7925C11.3171 21.7925 10.8612 21.6036 10.525 21.2675C10.1889 20.9313 10 20.4754 10 20"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
              </svg>
            </div>
            <Notify @closeNotify="toggleNotify" v-if="notifyOpened" />
          </div>
          <div class="header__menu-button d-xl-none" @click="openMenu">
            <div class="header__menu-button-line"></div>
          </div>
          <Auth v-if="openAuth" @closeAuth="closeAuth" />
        </div>
        <HelperStart
          @closeHelp="closeHelp"
          @startHelp="startHelp"
          v-if="helperStart"
          :text="helperText"
        />
        <div class="helper-start auth-popup" v-if="authAlert">
          <div class="helper-start__close" @click="closeAuthPopup()">
            <svg
              width="16"
              height="16"
              viewBox="0 0 16 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3.5 3.5L12.5 12.5"
                stroke="#3C4242"
                stroke-linecap="square"
              />
              <path
                d="M12.5 3.5L3.5 12.5"
                stroke="#3C4242"
                stroke-linecap="square"
              />
            </svg>
          </div>
          <div class="helper-start__row">
            <div class="helper-start__icon">
              <svg
                width="48"
                height="48"
                viewBox="0 0 48 48"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle cx="24" cy="24" r="24" fill="#F9DD99" />
                <path
                  d="M30.5 31.5H26.5"
                  stroke="#830051"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M28.5 33.5V29.5"
                  stroke="#830051"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M24.16 22.87C24.06 22.86 23.94 22.86 23.83 22.87C21.45 22.79 19.56 20.84 19.56 18.44C19.55 15.99 21.54 14 23.99 14C26.44 14 28.43 15.99 28.43 18.44C28.43 20.84 26.53 22.79 24.16 22.87Z"
                  stroke="#830051"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M23.99 33.8101C22.17 33.8101 20.36 33.3501 18.98 32.4301C16.56 30.8101 16.56 28.1701 18.98 26.5601C21.73 24.7201 26.24 24.7201 28.99 26.5601"
                  stroke="#830051"
                  stroke-width="1.5"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </div>
            <div class="helper-start__title">
              Вы сейчас смотрите сайт как незарегистрированный пользователь
              <br />
              <br />
              Зарегистрируйтесь или войдите чтобы получить доступ ко всем
              материалам сайта
            </div>
          </div>
          <div class="helper-start__buttons">
            <div
              @click="toRegister()"
              class="helper-start__button button button_pink"
            >
              Зарегистрироваться
            </div>
            <div
              @click="toLogin()"
              class="helper-start__button button button_gray"
            >
              Войти
            </div>
          </div>
        </div>
      </div>
      <div class="overlay" @click="closeMenu" v-if="menuOpen"></div>
      <transition name="modal-v">
        <HeaderMenuMob
          @closeAuth="closeAuth"
          :menu="menu"
          :topMenu="topMenu"
          @closeMenu="closeMenu"
          :class="{ 'header-menu_opened': menuOpen }"
          v-show="menuOpen"
          v-if="$root.isMobile || $root.isTablet"
        />
      </transition>
    </div>
    <div class="header__bottom-menu" v-if="!$root.isMobile && !$root.isTablet">
      <div class="content">
        <div class="header__menu header-menu d-none d-xl-flex">
          <div
            class="header-menu__group"
            v-for="(group, ind) in menu.filter((el) => !el.hide)"
            v-show="!group.hide"
            :key="ind"
          >
            <div class="header-menu__item">
              <div
                @click="
                  toMenuItemFull(group.link, group.title, group.title, 'None')
                "
                v-html="group.title"
                :data-id="group.ref"
                class="header-menu__link"
              ></div>
              <div class="header-menu__item-icon" v-if="group.childrens">
                <!-- v-if="group.childrens"-->
                <svg
                  width="17"
                  height="16"
                  viewBox="0 0 17 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M14 5.49988L9 10.4999L4 5.49988"
                    stroke="currentColor"
                    stroke-linecap="square"
                  />
                </svg>
              </div>
            </div>

            <div
              class="header-menu__list header-menu__list_l2"
              v-if="group.childrens && group.childrens.length"
            >
              <div class="header-menu__list_l2-overflow">
                <div
                  class="header-menu__group"
                  v-for="(children, ind) in group.childrens"
                  :key="ind"
                >
                  <div class="header-menu__item">
                    <div
                      v-if="typeof children.link === 'object'"
                      @click="
                        toMenuItemFull(
                          children.link,
                          children.title,
                          group.title,
                          children.title
                        )
                      "
                      class="header-menu__link"
                    >
                      <span v-html="children.title"></span>
                      <div
                        class="header-menu__item-icon"
                        v-if="children.childrens"
                      >
                        <svg
                          width="7"
                          height="12"
                          viewBox="0 0 7 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L6 6L1 11"
                            stroke="currentColor"
                            stroke-linecap="square"
                          />
                        </svg>
                      </div>
                    </div>
                    <div
                      @click="
                        toMenuItemFull(
                          children.link,
                          children.title,
                          group.title,
                          children.title
                        )
                      "
                      v-else
                      class="header-menu__link"
                    >
                      <span v-html="children.title"></span>
                      <div
                        class="header-menu__item-icon"
                        v-if="children.childrens"
                      >
                        <svg
                          width="7"
                          height="12"
                          viewBox="0 0 7 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M1 1L6 6L1 11"
                            stroke="currentColor"
                            stroke-linecap="square"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div
                    class="header-menu__list header-menu__list_l3"
                    v-if="children.childrens && children.childrens.length"
                  >
                    <div
                      class="header-menu__list-title"
                      v-html="children.title"
                    ></div>
                    <span v-for="(link, ind) in children.childrens" :key="ind">
                      <div
                        @click="
                          toMenuItemFull(
                            link.link,
                            link.title,
                            group.title,
                            children.title
                          )
                        "
                        class="header-menu__link"
                        :class="{
                          'header-menu__link_subgroup':
                            link.type === 'subgroup',
                        }"
                        v-html="link.title"
                      ></div>
                      <div
                        class="header-menu__list_l4"
                        v-if="link.diseases && link.diseases.length"
                      >
                        <span
                          v-for="(link_l4, ind) in link.diseases"
                          :key="ind"
                        >
                          <div
                            @click="
                              toMenuItemFull(
                                link_l4.link,
                                link_l4.title,
                                group.title,
                                children.title
                              )
                            "
                            class="header-menu__link"
                            v-html="link_l4.title"
                          ></div>
                        </span>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Auth from "./Auth.vue";
import HeaderMenuMob from "./HeaderMenuMob.vue";
import { bus } from "@/main";
import Notify from "@/components/pageComponents/Notify.vue";
import PopUpDefault from "@/components/pageComponents/PopUpDefault.vue";
import HelperStart from "@/components/main/HelperStart.vue";

export default {
  name: "Header",
  components: { Auth, HeaderMenuMob, Notify, HelperStart },
  props: {
    theme: String,
  },
  data: (vm) => ({
    helperText: {
      title: "Добро пожаловать на AZ-MOST!",
      description:
        "На портале представлена экспертная информация о заболеваниях, современных подходах к терапии и многое другое",
    },
    openAuth: false,
    menuOpen: false,
    searchOpened: false,
    notifyOpened: false,
    search: "",
    nosologysMenu: {
      title: "Терапевтические области",
      link: { name: "Nosology" },
      ref: "headerNos",
      childrens: [],
    },
    videoTypes: [],
    textTypes: [],
    podcastsTypes: [],
    helperStart: false,
    authAlert: false,
    approved: [
      "anna.rezunkova@astrazeneca.com",
      "tamara.archakova@astrazeneca.com",
      "yuri.nivin@astrazeneca.com",
      "dmitrii.tikhonov@astrazeneca.com",
      "natia.kalmychkova@astrazeneca.com",
    ],
  }),
  computed: {
    ...mapGetters([
      "user",
      "searchResults",
      "Nosologys",
      "VideoTypesFilter",
      "TextTypesFilter",
      "PodcastsTypesFilter",
      "notify",
    ]),
    disabledPages() {
      return ["Forsiga", "EnhertuESMO", "SeeMore"];
    },
    menu() {
      return [
        this.nosologysMenu,
        {
          title: "Препараты АЗ",
          ref: "headerMed",
          link: { name: "Medications" },
        },
        {
          title: "Библиотека",
          ref: "headerLib",
          link: { name: "Library" },
          childrens: [
            {
              title: "Публикации",
              link: { name: "TextMaterials" },
              childrens: this.textTypes,
            },
            {
              title: "Видеоматериалы",
              link: { name: "VideoMaterials" },
              childrens: this.videoTypes,
            },
            {
              title: "Подкасты",
              link: { name: "Podcasts" },
              childrens: this.podcastsTypes,
            },
          ],
        },
      ];
    },
    topMenu() {
      return [
        {
          title: "Проекты",
          ref: "headerProjects",
          link: { name: "Projects" },
          childrens: [
            {
              title: "Интерактивный клинический случай",
              link: { name: "InteractiveClinicalCase" },
            },
            {
              title: "Диагностика методом сухого пятна крови",
              link: { name: "Mspk" },
            },
            {
              title: "Мониторинг сахарного диабета: Что важно знать?",
              link: { name: "SD2" },
            },
            {
              title: 'Онлайн-квест для врачей "Сим-Сим"',
              link: "https://sim-sim.az-most.ru/login/",
            },
            {
              title: "Все что нужно знать о бета-блокаторах",
              link: { name: "BetalockLand" },
            },
            {
              title: "ВсмATTRиваемся в полинейропатию",
              link: "https://amyloidosis.az-most.ru",
            },
            {
              title: "Легенда кардиологии",
              link: "https://cardio-legend.az-most.ru/",
            },
            {
              title: "Эпителиум",
              link: { name: "Epitelium" },
            },
            {
              title: "Программа Galaxy - все об атеросклерозе и не только...",
              link: "https://crestor-galaxy.az-most.ru/",
            },
            {
              title: "Все проекты",
              link: { name: "Projects" },
            },
          ],
        },
        {
          title: "Мероприятия",
          ref: "headerEvents",
          link: { name: "Events" },
          childrens: [
            {
              title: "Предстоящие мероприятия",
              link: { name: "Events" },
            },
            {
              title: "Архив мероприятий",
              link: { name: "ArchiveEvents" },
            },
          ],
        },
      ];
    },
    isAuth() {
      return (
        this.user &&
        !!Object.keys(this.user).length &&
        typeof this.user === "object"
      );
    },
    hideButton() {
      return (
        this.user &&
        this.user?.email &&
        this.user.email.toLowerCase().includes("@astrazeneca.com") &&
        !this.approved.includes(this.user.email.toLowerCase())
      );
    },
  },
  methods: {
    ...mapActions([
      "fetchSearch",
      "fetchLibraryFilter",
      "clearSearch",
      "checkTutorial",
      "getNotify",
    ]),

    getLocalStorageItem(item) {
      return localStorage.getItem(item);
    },
    toggleNotify() {
      this.notifyOpened = !this.notifyOpened;
      bus.$emit("scrollLock", this.notifyOpened);
    },
    toMedInfo() {
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "medinfo click", {
          "medinfo click": {
            ...this.$root.ymFields,
          },
        });
      }
      this.$router
        .push({
          name: "MedInfo",
        })
        .catch(() => {});
    },
    closeNotify() {
      this.notifyOpened = false;
      bus.$emit("scrollLock", false);
    },
    toMenuItemFull(to, item, first, second) {
      if (!to) return;
      bus.$emit("scrollLock", false);
      const vm = this;
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "header menu click", {
          "header menu click": {
            "menu item": item,
            "first menu level": first,
            "second menu level": second,
            ...this.$root.ymFields,
          },
        });
      }
      if (typeof to !== "object") {
        window.open(to, "_blank");
      } else {
        this.$router.push(to).catch(() => {});
      }
    },
    toCabinet(to) {
      bus.$emit("scrollLock", false);
      const vm = this;
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "profile logo click", {
          "profile logo click": {
            ...this.$root.ymFields,
          },
        });
      }
      this.$router.push(to).catch(() => {});
    },
    toSearchIcon() {
      const vm = this;
      this.searchOpened = true;
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "search icon click", {
          "search icon click": {
            ...this.$root.ymFields,
          },
        });
      }
    },
    async toRegister() {
      bus.$emit("scrollLock", false);
      localStorage.setItem("source", "header_popup");
      const vm = this;
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "registration popup interaction", {
          "registration popup interaction": {
            action: "Зарегистрироваться",
            ...this.$root.ymFields,
          },
        });
      }

      window.open(this.$root.ssoLinks.registration, "_self");
    },
    async toLogin() {
      bus.$emit("scrollLock", false);
      const vm = this;
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "registration popup interaction", {
          "registration popup interaction": {
            action: "Войти",
            ...this.$root.ymFields,
          },
        });
      }
      window.open(this.$root.ssoLinks.login, "_self");
    },
    closeAuth() {
      this.openAuth = false;
    },
    closeMenu() {
      bus.$emit("scrollLock", false);
      this.menuOpen = false;
    },
    openMenu() {
      bus.$emit("scrollLock", true);
      this.menuOpen = true;
    },
    closeSearch() {
      this.search = "";
      this.searchOpened = false;
      this.clearSearch();
    },
    startHelp() {
      bus.$emit("startHelp");
      this.helperStart = false;
    },
    closeHelp(check) {
      if (check) {
        this.checkTutorial({ id: this.user.id, flags: ["tutorial"] });
        if (typeof ym !== "undefined") {
          ym(91468266, "reachGoal", "onboarding start", {
            "onboarding start": {
              "banner interaction": "skip",
              ...this.$root.ymFields,
            },
          });
        }
      }
      this.helperStart = false;
      bus.$emit("scrollLock", false);
    },
    closeAuthPopup() {
      this.authAlert = false;
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "registration popup interaction", {
          "registration popup interaction": {
            action: "Закрыть",
            ...this.$root.ymFields,
          },
        });
      }
    },
    searchResultClick(res) {
      if (typeof ym !== "undefined") {
        ym(91468266, "reachGoal", "search result click", {
          "search result click": {
            "search result": res.origTitle,
            ...this.$root.ymFields,
          },
        });
      }
      this.$router.push(this.toSearchResult(res)).catch(() => {});
    },
    toSearchResult(res) {
      switch (res.type) {
        case "desease":
          return {
            name: "Disease",
            params: { slug: res.nosology, disease: res.slug },
          };
        case "disease":
          return {
            name: "Disease",
            params: { slug: res.nosology, disease: res.slug },
          };
        case "nosology":
          return { name: "NosologyDetail", params: { slug: res.slug } };
        case "drug":
          return { name: "DrugsTemplates", params: { medication: res.slug } };
        case "event":
          return { name: "EventDetail", params: { id: res.id } };
        case "text_material":
          return { name: "TextDetail", params: { slug: res.slug } };
        case "video_material":
          return { name: "VideoDetail", params: { slug: res.slug } };
        case "podcast":
          return { name: "PodcastDetail", params: { slug: res.slug } };
        default:
          return "#";
      }
    },
  },
  async mounted() {
    bus.$on("openMenu", this.openMenu);
    bus.$on("closeMenu", this.closeMenu);
    await this.fetchLibraryFilter();
    if (this.Nosologys && this.Nosologys.length) {
      this.nosologysMenu.childrens = this.Nosologys.map(function (item) {
        return {
          title: item.title,
          link: { path: item.link },
          childrens: [
            ...item.links,
            ...item.subgroups.map((el) => ({ ...el, type: "subgroup" })),
          ],
        };
      });
    }
    if (
      this.user &&
      Object.keys(this.user).length &&
      this.user.diseases.length &&
      this.user.specialities.length
    ) {
      this.getNotify(this.user.id);
    }
    if (
      this.user &&
      Object.keys(this.user).length &&
      typeof this.user === "object" &&
      this.$route.name === "MainPage" &&
      ((this.user.flags && !this.user.flags.includes("tutorial")) ||
        !this.user.flags)
    ) {
      bus.$emit("scrollLock", true);
      this.helperStart = true;
    }
    if (
      !localStorage.getItem("token") &&
      !!!Object.keys(this.user).length &&
      !!this.$route.query.access &&
      this.$route.name !== "Galaxy" &&
      this.$route.name !== "TimeHobl" &&
      this.$route.name !== "Forsiga" &&
      this.$route.name !== "Krepost" &&
      this.$route.name !== "NarodnyeSkazki" &&
      this.$route.name !== "Stream" &&
      this.$route.name !== "Epitelium" &&
      this.$route.name !== "EpiteliumGame" &&
      this.$route.name !== "EpiteliumQuiz" &&
      this.$route.name !== "SeeMore" &&
      this.$route.name !== "SevereAsthma" &&
      this.$route.name !== "PodPrikrutiem"
    ) {
      setTimeout(() => {
        this.authAlert = true;
        if (typeof ym !== "undefined") {
          ym(91468266, "reachGoal", "registration popup show", {
            "registration popup show": {
              ...this.$root.ymFields,
            },
          });
        }
      }, 10000);
    }
  },
  destroyed() {
    bus.$off("openMenu", this.openMenu);
    bus.$off("closeMenu", this.closeMenu);
  },
  watch: {
    "$route.fullPath": async function () {
      if (this.menuOpen) {
        this.closeMenu();
      }

      this.closeSearch();
      this.clearSearch();
      if (this.notifyOpened) {
        this.closeNotify();
      }

      this.tgPopupState = false;
    },
    user() {
      if (
        this.user &&
        Object.keys(this.user).length &&
        typeof this.user === "object" &&
        this.$route.name === "MainPage" &&
        ((this.user.flags && !this.user.flags.includes("tutorial")) ||
          !this.user.flags)
      ) {
        bus.$emit("scrollLock", true);
        this.helperStart = true;
      }
      if (
        this.user &&
        Object.keys(this.user).length &&
        this.user.diseases.length &&
        this.user.specialities.length
      ) {
        this.getNotify(this.user.id);
      }
    },
    async search() {
      if (this.search.length > 2) {
        this.fetchSearch(this.search);
      } else {
        this.clearSearch();
      }
    },
    async Nosologys() {
      if (this.Nosologys && this.Nosologys.length) {
        this.nosologysMenu.childrens = this.Nosologys.map(function (item) {
          return {
            title: item.title,
            link: { path: item.link },
            childrens: [
              ...item.links,
              ...item.subgroups.map((el) => ({ ...el, type: "subgroup" })),
            ],
          };
        });
      }
    },
    async VideoTypesFilter() {
      if (this.VideoTypesFilter && this.VideoTypesFilter.length) {
        this.videoTypes = this.VideoTypesFilter.map(function (item) {
          return {
            title: item.name,
            link: { name: "VideoMaterials", query: { type: item.slug } },
          };
        });
      }
    },
    async TextTypesFilter() {
      if (this.TextTypesFilter && this.TextTypesFilter.length) {
        this.textTypes = this.TextTypesFilter.map(function (item) {
          return {
            title: item.name,
            link: { name: "TextMaterials", query: { type: item.slug } },
          };
        });
      }
    },
    async PodcastsTypesFilter() {
      if (this.PodcastsTypesFilter && this.PodcastsTypesFilter.length) {
        this.podcastsTypes = this.PodcastsTypesFilter.map(function (item) {
          return {
            title: item.name,
            link: { name: "Podcasts", query: { type: item.slug } },
          };
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.verify-block {
  padding: 6px;
  font-family: "Roboto", sans-serif;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 21px;
  color: #ffffff;
  background-color: #830051;
  text-align: center;
}

.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 100;
  background: rgba(31, 31, 31, 0.2);
}

.helper-start {
  width: 343px;
  padding: 24px 20px 0;
  background-color: #fff;
  overflow: hidden;
  border-radius: 8px;
  box-shadow: 0px 4px 12px rgba(87, 0, 54, 0.1);

  position: fixed;
  top: 125px;
  right: 45px;
  @media screen and (max-width: 1220px) {
    right: 15px;
  }

  @media screen and (max-width: 767px) {
    width: 100%;
    right: 0;
    top: 61px;
  }

  &__close {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    z-index: 100;
  }

  &__row {
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  &__title {
    margin-left: 12px;
    font-family: "Roboto", sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 22px;
    color: #1f1f1f;
  }

  &__buttons {
    margin: 24px -20px 0;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &__button {
    width: 50%;
    border-radius: 0;
  }
}

.auth-popup {
  width: 384px;
  position: fixed;
  top: 125px;
  right: 45px;
  @media screen and (max-width: 1220px) {
    right: 15px;
  }

  @media screen and (max-width: 767px) {
    width: 100%;
    right: 0;
    top: 61px;
  }
  .helper-start {
    &__title {
      font-size: 14px;
      line-height: 20px;
    }

    &__row {
      align-items: flex-start;
    }
  }
}

.header {
  position: relative;
  z-index: 110;
  border-bottom: 1px solid #b2b4b4;
  background-color: #fff;

  @media screen and (max-width: 767px) {
    & .content {
      padding: 10px 16px;
    }
  }

  &__cabinet-button {
    font-size: 14px;
  }

  &__logo {
    padding: 16px 0;
    @media screen and (max-width: 767px) {
      padding: 0;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  &__row {
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: stretch;
  }

  &__bottom-menu {
    background-color: #f8f8f8;
  }

  &-menu {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 100%;

    &_top {
      margin-left: 30px;
      height: auto;
      z-index: 10;
    }

    &__link {
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      cursor: pointer;
      @media screen and (max-width: 1220px) {
        white-space: nowrap;
      }
    }

    & > &__group {
      height: 100%;
      display: flex;
      padding: 16px 0;

      &:first-child {
        & .header-menu__list_l2 {
          left: 0;
          right: auto;
        }
      }
    }

    &__group {
      margin-right: 30px;
      position: relative;

      &:last-child {
        margin-right: 0;
      }

      &:first-child {
        margin-left: 0;
      }

      &:hover {
        > .header-menu__list {
          max-height: 360px;
          height: auto;
          overflow: visible;
          z-index: 5;
        }

        > .header-menu__item {
          color: #d0006f;
          & > .header-menu__link {
            color: #d0006f;
          }
        }
      }
    }

    &__list {
      position: absolute;
      top: 100%;
      left: 0;
      width: fit-content;
      max-height: 0;
      overflow: hidden;
      background-color: #fff;

      & .header-menu__link {
        & > span {
          display: block;
          margin-right: auto;
        }
        padding: 16px;

        &:last-child {
          margin-bottom: 0;
        }
      }

      &_l2 {
        &-overflow {
          overflow-y: auto;
          height: max-content;
          max-height: 360px;

          &::-webkit-scrollbar {
            width: 5px;
            height: 8px;
            border-radius: 5px;
          }

          &::-webkit-scrollbar-thumb {
            background-color: #830051;
            border-radius: 5px;
            height: 8px;
          }

          &::-webkit-scrollbar--track-piece {
            border-radius: 5px;
            background-color: #ebefee;
          }

          &::-webkit-scrollbar-track {
            border-radius: 5px;
            background-color: #ebefee;
            border: 3px solid #fff;
          }

          &::-moz-scrollbar-button:decrement,
          &::-moz-scrollbar-button:increment,
          &::-moz-scrollbar-button:vertical:start:decrement,
          &::-moz-scrollbar-button:vertical:end:increment,
          &::-moz-scrollbar-button:horizontal:start:decrement,
          &::-moz-scrollbar-button:horizontal:end:increment,
          &::-webkit-scrollbar-button:vertical:start:decrement,
          &::-webkit-scrollbar-button:vertical:end:increment,
          &::-webkit-scrollbar-button:horizontal:start:decrement,
          &::-webkit-scrollbar-button:horizontal:end:increment {
            width: 0px !important;
            height: 0px !important;
          }
        }
        min-width: 280px;
        .header-menu {
          &__group {
            position: relative;
            margin-right: 0;
            position: static;
            transition: 0.3s;

            &:hover {
              background-color: #ebefee;
              color: #d0006f;
            }

            &:hover {
              > .header-menu__list {
                max-width: 100%;
                overflow: hidden;
                height: fit-content;
                min-width: 340px;
                min-height: 100%;
              }
            }
          }

          &__list {
            padding-right: 0;
            max-height: none;
            max-width: 0%;
            background-color: #ebefee;

            &-title {
              padding: 18px 16px 8px;
              font-family: "Roboto", sans-serif;
              font-style: normal;
              font-weight: 700;
              font-size: 16px;
              line-height: 21px;
              color: #3c4242;
            }
          }

          &__item {
            padding-right: 21px;
            min-width: 234px;
          }
        }
      }

      &_l3 {
        padding-bottom: 25px;
        position: absolute;
        left: 95%;
        top: 0;
        z-index: 1;
        overflow-y: auto !important;

        &::-webkit-scrollbar {
          width: 5px;
          height: 8px;
          border-radius: 5px;
        }

        &::-webkit-scrollbar-thumb {
          background-color: #830051;
          border-radius: 5px;
          height: 8px;
        }

        &::-webkit-scrollbar--track-piece {
          border-radius: 5px;
          background-color: #ebefee;
        }

        &::-webkit-scrollbar-track {
          border-radius: 5px;
          background-color: #ebefee;
          border: 3px solid #fff;
        }

        &::-moz-scrollbar-button:decrement,
        &::-moz-scrollbar-button:increment,
        &::-moz-scrollbar-button:vertical:start:decrement,
        &::-moz-scrollbar-button:vertical:end:increment,
        &::-moz-scrollbar-button:horizontal:start:decrement,
        &::-moz-scrollbar-button:horizontal:end:increment,
        &::-webkit-scrollbar-button:vertical:start:decrement,
        &::-webkit-scrollbar-button:vertical:end:increment,
        &::-webkit-scrollbar-button:horizontal:start:decrement,
        &::-webkit-scrollbar-button:horizontal:end:increment {
          width: 0px !important;
          height: 0px !important;
        }
        & .header-menu__link {
          padding-bottom: 0;
        }

        &__item {
          padding: 16px;
        }

        &::before {
          width: 100%;
          height: 360px;

          content: "";
          display: block;
          background-color: #000;
          position: absolute;
          left: -100%;
          z-index: 0;
          opacity: 0;
        }
      }

      &_l4 {
        border-left: 1px solid #3c4242;
        margin-left: 15px;
        padding: 0 0 10px;
        margin-bottom: 15px;
      }
    }

    &__item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
      cursor: pointer;
      position: relative;
      z-index: 6;

      &-icon {
        margin-left: 4px;
      }
    }

    &__link {
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 15px;
      line-height: 21px;
      color: #3c4242;
      transition: 0.3s;

      &_subgroup {
        font-weight: 600;
        font-size: 14px;
        & * {
          color: inherit !important;
        }
      }

      &:hover {
        color: #d0006f;
      }
    }
  }

  &__container {
    margin-right: auto;
    margin-left: 32px;
    display: flex;
    width: 100%;
    justify-content: flex-start;
    align-items: center;

    @media screen and (max-width: 1220px) {
      margin-left: 16px;
      margin-right: 0;
    }

    @media screen and (max-width: 767px) {
      &_opened {
        padding: 24px 16px;
        margin-left: 0;
        margin-right: 0;
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100vh;
        background-color: #fff;
        z-index: 100000;
        align-items: flex-start;
      }
    }
  }

  &__tools {
    display: flex;
    justify-content: flex-start;
    align-items: center;

    @media screen and (max-width: 1220px) {
      margin-left: auto;
    }
  }

  &__notify {
    position: relative;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #ebefee;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #830051;
    transition: 0.3s;
    cursor: pointer;

    &:hover {
      background-color: #d8dfde;
    }

    &-wrap {
      position: relative;
      width: 40px;
      height: 40px;
    }

    &-sticker {
      position: absolute;
      top: 2px;
      right: 2px;
      width: 8px;
      height: 8px;
      background-color: #830051;
      border-radius: 50%;
      display: block;
    }
  }

  &__search {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #ebefee;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #830051;
    transition: 0.3s;
    cursor: pointer;

    &:hover {
      background-color: #d8dfde;
    }

    &-results {
      padding: 16px;
      position: absolute;
      top: calc(100% + 10px);
      left: 0;
      width: 100%;
      background-color: #fff;
      box-shadow: 0px 0px 4px 2px rgba(184, 184, 184, 0.47);
      border-radius: 8px;
      z-index: 10;

      @media screen and (max-width: 767px) {
        box-shadow: none;
        padding: 16px 0 0;
      }
    }

    &-result {
      display: block;
      padding: 8px 12px;
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 16px;
      color: #b2b4b4;
      transition: 0.3s;
      border-radius: 8px;
      cursor: pointer;

      &:hover {
        background-color: #f8f8f8;
        color: #830051;
      }

      @media screen and (max-width: 767px) {
        padding: 0;
        margin-bottom: 16px;

        &:hover {
          background-color: transparent;
          color: #b2b4b4;
        }
      }
    }

    &-close {
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      margin-left: 16px;
      color: #3c4242;
      transition: 0.3s;

      &:hover {
        color: #830051;
      }
    }

    &-input-container {
      position: relative;
      padding: 16px 0 16px;
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: flex-start;
      align-content: center;
      .header__search {
        flex-shrink: 0;
        &:hover {
          background-color: #ebefee;
        }
      }

      @media screen and (max-width: 767px) {
        height: auto;
        padding: 0;
      }
    }

    &-input {
      position: relative;
      width: 100%;
      display: flex;
      justify-content: flex-start;
      align-items: stretch;
      background-color: #ebefee;
      border-radius: 999px;

      & > input {
        width: 100%;
        background-color: transparent;
        border: 0;
        outline: none;
        font-family: "Roboto", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 21px;
        color: #000;
      }
    }
  }

  &__register {
    width: 193px;
    height: 40px;
    margin-left: 16px;
  }

  &__sign-in {
    width: 81px;
    height: 40px;
    margin-left: 16px;
  }

  &-user {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-left: 16px;
    cursor: pointer;

    &__image-container {
      margin-right: 8px;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      overflow: hidden;
      border: 1px solid #ebefee;
    }

    &__image {
      width: 100%;
      height: 100%;
      object-fit: scale-down;
      object-position: center;
    }

    &__name {
      font-family: "Roboto", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 14px;
      line-height: 21px;
      color: #830051;
    }
  }

  @media screen and (max-width: 1220px) {
    &__menu-button {
      margin-left: 16px;
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      cursor: pointer;
      z-index: 100;
      border: 1px solid #ebefee;
      border-radius: 50%;

      &-line {
        position: relative;
        top: 1px;
        width: 15px;
        height: 2px;
        background-color: #830051;
        &::before,
        &::after {
          position: absolute;
          top: 0;
          left: 0;
          transform: translateY(6px);
          display: block;
          width: 100%;
          height: 100%;
          content: "";
          background-color: #830051;
        }
        &::after {
          transform: translateY(6px);
        }
        &::before {
          transform: translateY(-6px);
        }
      }
    }
  }
}
</style>
<style>
.header__search-result > * {
  color: #830051;
}
.header-menu__link_subgroup > * {
  color: inherit !important;
}
</style>
<style lang="scss">
.modal-v-enter-active,
.modal-v-leave-active {
  transition: 0.3s;
}
.modal-v-enter-active {
  right: -100%;
}
.modal-v-enter-to,
.modal-v-leave-from {
  right: 0% !important;
}
.modal-v-enter-from,
.modal-v-leave-to {
  right: -100% !important;
}
</style>

<style lang="scss" scoped>
.fixed-header .header {
  &.black {
    background-color: #000;
    .header {
      &__menu-button-line {
        background-color: #fff;
        &::before,
        &::after {
          background-color: #fff;
        }
      }
      &__search {
        background-color: transparent;
        border: 2px solid #fff;
        color: #fff;
      }

      &__container_opened {
        .header__search {
          background-color: #ebefee;
          color: #830051;
          border: 0;
        }
      }

      &__search-close {
        color: #fff;
      }

      &__notify {
        background-color: transparent;
        border: 2px solid #fff;
        color: #fff;
      }

      &__bottom-menu {
        background-color: #000;
      }

      &__menu > .header-menu__group {
        & > .header-menu__item {
          & > .header-menu__link {
            color: #fff;
          }
          & > .header-menu__item-icon > svg {
            color: #fff;
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
.tgPopup {
  height: auto !important;
  position: static !important;
  background-color: transparent !important;
  @media screen and (max-width: 767px) {
    position: absolute !important;
    height: auto !important;
    width: 100vw !important;
    left: 0 !important;
    top: 100% !important;
  }

  & .modal-popup__container {
    height: auto !important;
    position: static !important;
    @media screen and (max-width: 767px) {
      padding: 0 !important;
      position: static !important;
      height: auto !important;
    }
  }

  & .modal-popup__content {
    position: fixed;
    bottom: 30px;
    right: calc((100vw - 1216px - 30px) / 2);
    z-index: 9999999;
    max-width: 384px !important;
    display: flex;
    flex-direction: column;
    padding: 24px;
    border-radius: 8px;
    background-color: #fafce9;
    box-shadow: 0px 4px 16px 0px rgba(87, 0, 54, 0.1);
    margin: 0;
    @media screen and (max-width: 1220px) {
      right: 30px;
    }
    @media screen and (max-width: 767px) {
      width: 100%;
      position: static;
      margin: 0 auto;
    }

    & svg {
      flex-shrink: 0;
    }
  }

  &_top {
    & .modal-popup__content {
      bottom: auto;
      top: 135px;
    }
  }

  & .modal-popup__close-btn {
    position: absolute;
    top: 0;
    right: 0;
    transform: translate(50%, -50%);
    border-radius: 50%;
    background-color: #fafce9;
    width: 24px;
    height: 24px;
    padding: 2px;
    display: flex;
    justify-content: center;
    align-items: center;
    & svg {
      width: 100%;
      flex-shrink: 0;
    }

    @media screen and (max-width: 767px) {
      top: 15px;
      right: 15px;
    }
  }

  & .modal-popup__text {
    font-family: "Roboto", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    color: #000;
    margin-bottom: 16px;
  }

  & .modal-popup__overlay {
    display: none;
  }
}
.tpPopup {
  & .modal-popup__content {
    margin: 0 auto;
    background-color: #ebefee;
    animation: fadeInLeft 0.3s linear;
  }

  & .modal-popup__text {
    font-weight: 700;
    animation: fadeInUp 0.3s 0.3s linear both;
    opacity: 0;
  }

  & .modal-popup__description {
    font-family: "Roboto", sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    text-align: left;
    opacity: 0;
    color: #000;
    margin-bottom: 16px;
    animation: fadeInUp 0.3s 0.6s linear both;
  }

  & .modal-popup__btn-accept {
    animation: fadeInUp 0.3s 0.9s linear both;
    opacity: 0;
  }

  & svg {
    animation: fadeIn 0.3s 0.3s linear both;
  }

  @keyframes fadeInLeft {
    from {
      transform: translateX(30px);
      opacity: 0;
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes fadeInUp {
    from {
      transform: translateY(10px);
      opacity: 0;
    }

    to {
      opacity: 1;
      transform: translateX(0);
    }
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
    }

    to {
      opacity: 1;
    }
  }
}
</style>
